import React from "react";
import { StyledQuotaDisplayBar, StyledQuotaBar, StyledQuotaDisplayText } from "./styles";
import Utils from "../../../Utils";
import { PRICING_PLANS } from "../../../../../src/shared/constants";
import { Link } from "react-router-dom";
import { formatDateWithTimezone } from "../../../utils/formatDateWithTimezone";

const SettingsQuotaBar = ({ subscription, trial, showRecentActivityLog, setShowRecentActivityLog }) => {
  if (!subscription || !subscription.usesQuota) return null;
  const userPlan = subscription.currentPlan();

  let wordsLeft = subscription.totalQuota;
  let allotment = (userPlan && userPlan.allotment) || PRICING_PLANS[subscription.data.version].trialQuota;

  if (wordsLeft < 0) wordsLeft = 0;

  let wordsUsed = allotment - wordsLeft;

  if (isNaN(wordsUsed) || wordsUsed > allotment) {
    wordsUsed = allotment;
  }

  const fillBarAmount = (wordsLeft / allotment) * 100;

  const overage = subscription.overage().words > 0 ? subscription.overage().words : null;

  const wordsOrCredits = subscription.usesLedgers ? "credits" : "AI words";
  const wordsOrCreditsUpperCase = subscription.usesLedgers ? "Credits" : "Words";
  return (
    <StyledQuotaBar>
      <StyledQuotaDisplayBar filledAmount={fillBarAmount}>
        <div />
      </StyledQuotaDisplayBar>
      <StyledQuotaDisplayText className="settings-quota-bar-display-text">
        {Utils.numberWithCommas(wordsLeft)} of {Utils.numberWithCommas(allotment)} {wordsOrCredits} left.
        <br />
        {subscription.canPurchasePacks() && <Link to="/app/purchase-packs">Buy More Credits</Link>}
        <br />
        {subscription.usesLedgers && (
          <button
            type="button recent-activity"
            onClick={() => setShowRecentActivityLog(!showRecentActivityLog)}
            aria-label={showRecentActivityLog ? "close recent activity log" : "open recent activity log"}
          >
            {showRecentActivityLog ? "Hide Recent Activity" : "Show Recent Activity"}
          </button>
        )}
        <br />
        {!trial && subscription?.currentPlan()?.interval === "year" && subscription.data.provisionedAt && (
          <>
            <br />
            {wordsOrCreditsUpperCase} refresh on <br /> {formatDateWithTimezone(subscription.nextProvisionDate())}
            <br />
          </>
        )}
        {overage && (
          <>
            (Overage: {overage} {wordsOrCredits})
          </>
        )}
      </StyledQuotaDisplayText>
    </StyledQuotaBar>
  );
};

export default SettingsQuotaBar;
